/* GET CAMPAIGN */
export const GET_CAMPAIGNS = "GET_CAMPAIGNS"
export const GET_CAMPAIGNS_SUCCESS = "GET_CAMPAIGNS_SUCCESS"
export const GET_CAMPAIGNS_ERROR = "GET_CAMPAIGNS_ERROR"

/* GET CAMPAIGN */
export const GET_CAMPAIGN_BY_ID = "GET_CAMPAIGN_BY_ID"
export const GET_CAMPAIGN_BY_ID_SUCCESS = "GET_CAMPAIGN_BY_ID_SUCCESS_BY_ID"
export const GET_CAMPAIGN_BY_ID_ERROR = "GET_CAMPAIGN_BY_ID_ERROR"

/*CREATE CAMPAIGN */
export const CREATE_NEW_CAMPAIGN = "CREATE_NEW_CAMPAIGN"
export const NEW_CAMPAIGN_SUCCESS = "NEW_CAMPAIGN_SUCCESS"
export const NEW_CAMPAIGN_ERROR = "NEW_CAMPAIGN_ERROR"

/*DUPLICATE CAMPAIGN */
export const DUPLICATE_CAMPAIGN = "DUPLICATE_CAMPAIGN"
export const DUPLICATE_CAMPAIGN_SUCCESS = "DUPLICATE_CAMPAIGN_SUCCESS"
export const DUPLICATE_CAMPAIGN_ERROR = "DUPLICATE_CAMPAIGN_ERROR"

// using new campaign success and failure for duplicate

/*MODIFY CAMPAIGN */
export const MODIFY_CAMPAIGN = "MODIFY_CAMPAIGN"
export const MODIFY_CAMPAIGN_SUCCESS = "MODIFY_CAMPAIGN_SUCCESS"
export const MODIFY_CAMPAIGN_ERROR = "MODIFY_CAMPAIGN_ERROR"

/*DELETE CAMPAIGN */
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN"
export const DELETE_CAMPAIGN_SUCCESS = "DELETE_CAMPAIGN_SUCCESS"
export const DELETE_CAMPAIGN_ERROR = "DELETE_CAMPAIGN_ERROR"

/*DELETE MULTIPLE CAMPAIGNS*/
export const DELETE_MULTIPLE_CAMPAIGN = "DELETE_MULTIPLE_CAMPAIGN"
export const DELETE_MULTIPLE_CAMPAIGN_SUCCESS = "DELETE_MULTIPLE_CAMPAIGN_SUCCESS"
export const DELETE_MULTIPLE_CAMPAIGN_ERROR = "DELETE_MULTIPLE_CAMPAIGN_ERROR"

/*ADD ADGROUP */
export const NEW_ADGROUP = "NEW_ADGROUP"
export const NEW_ADGROUP_SUCCESS = "NEW_ADGROUP_SUCCESS"
export const NEW_ADGROUP_ERROR = "NEW_ADGROUP_ERROR"

/*MODIFY ADGROUP */
export const MODIFY_ADGROUP = "MODIFY_ADGROUP"
export const MODIFY_ADGROUP_SUCCESS = "MODIFY_ADGROUP_SUCCESS"
export const MODIFY_ADGROUP_ERROR = "MODIFY_ADGROUP_ERROR"

/* FOR CAMPAGN AD */
export const NEW_CAMPAIGN_AD = "NEW_CAMPAIGN_AD"
export const NEW_CAMPAIGN_AD_SUCCESS = "NEW_CAMPAIGN_AD_SUCCESS"
export const NEW_CAMPAIGN_AD_ERROR = "NEW_CAMPAIGN_AD_ERROR"

/* FOR CAMPAGN AD */
export const MODIFY_CAMPAIGN_AD = "MODIFY_CAMPAIGN_AD"
export const MODIFY_CAMPAIGN_AD_SUCCESS = "MODIFY_CAMPAIGN_AD_SUCCESS"
export const MODIFY_CAMPAIGN_AD_ERROR = "MODIFY_CAMPAIGN_AD_ERROR"

/* FOR CAMPAGN AD */
export const DELETE_CAMPAIGN_AD = "DELETE_CAMPAIGN_AD"
export const DELETE_CAMPAIGN_AD_SUCCESS = "DELETE_CAMPAIGN_AD_SUCCESS"
export const DELETE_CAMPAIGN_AD_ERROR = "DELETE_CAMPAIGN_AD_ERROR"

/*ADD ADGROUP */
export const DUPLICATE_ADGROUP = "DUPLICATE_ADGROUP"
export const DUPLICATE_ADGROUP_SUCCESS = "DUPLICATE_ADGROUP_SUCCESS"
export const DUPLICATE_ADGROUP_ERROR = "DUPLICATE_ADGROUP_ERROR"

/*DELETE ADGROUP */
export const DELETE_ADGROUP = "DELETE_ADGROUP"
export const DELETE_ADGROUP_SUCCESS = "DELETE_ADGROUP_SUCCESS"
export const DELETE_ADGROUP_ERROR = "DELETE_ADGROUP_ERROR"


export const RESET_LAST_COMPLETED_ACTION = "RESET_LAST_COMPLETED_ACTION"

/*ADD ADGROUP TRACKING*/
export const NEW_ADGROUP_TRACKING = "NEW_ADGROUP_TRACKING"
export const NEW_ADGROUP_TRACKING_SUCCESS = "NEW_ADGROUP_TRACKING_SUCCESS"
export const NEW_ADGROUP_TRACKING_ERROR = "NEW_ADGROUP_TRACKING_ERROR"

export const RESET_COPY_SCHEDULE_TO_ALL_CAMPAIGNS = "RESET_COPY_SCHEDULE_TO_ALL_CAMPAIGNS"

export const GET_ACCOUNT_CAMPAIGNS = "GET_ACCOUNT_CAMPAIGNS"
export const GET_ACCOUNT_CAMPAIGNS_SUCCESS = "GET_ACCOUNT_CAMPAIGNS_SUCCESS"
export const GET_ACCOUNT_CAMPAIGNS_ERROR = "GET_ACCOUNT_CAMPAIGNS_ERROR"

/* GET FILTER VOLUME */
export const GET_FILTER_VOLUME = "GET_FILTER_VOLUME"
export const GET_FILTER_VOLUME_SUCCESS = "GET_FILTER_VOLUME_SUCCESS"
export const GET_FILTER_VOLUME_ERROR = "GET_FILTER_VOLUME_ERROR"

// GET CLICK CAMPAIGNS AGGREGATED INFO
export const GET_CLICK_CAMPAIGN_STATS = "GET_CLICK_CAMPAIGN_STATS"
export const GET_CLICK_CAMPAIGN_STATS_SUCCESS = "GET_CLICK_CAMPAIGN_STATS_SUCCESS"
export const GET_CLICK_CAMPAIGN_STATS_ERROR = "GET_CLICK_CAMPAIGN_STATS_ERROR"

export const GET_CLICK_CAMPAIGN_STATS_BY_ID = "GET_CLICK_CAMPAIGN_STATS_BY_ID"
export const GET_CLICK_CAMPAIGN_STATS_BY_ID_SUCCESS = "GET_CLICK_CAMPAIGN_STATS_BY_ID_SUCCESS"
export const GET_CLICK_CAMPAIGN_STATS_BY_ID_ERROR = "GET_CLICK_CAMPAIGN_STATS_BY_ID_ERROR"


//GET CALL CAMPAIGNS AGGREGATED INFO
export const GET_CALL_CAMPAIGN_STATS = "GET_CALL_CAMPAIGN_STATS"
export const GET_CALL_CAMPAIGN_STATS_SUCCESS = "GET_CALL_CAMPAIGN_STATS_SUCCESS"
export const GET_CALL_CAMPAIGN_STATS_ERROR = "GET_CALL_CAMPAIGN_STATS_ERROR"

export const GET_CALL_CAMPAIGN_STATS_BY_ID = "GET_CALL_CAMPAIGN_STATS_BY_ID"
export const GET_CALL_CAMPAIGN_STATS_BY_ID_SUCCESS = "GET_CALL_CAMPAIGN_STATS_BY_ID_SUCCESS"
export const GET_CALL_CAMPAIGN_STATS_BY_ID_ERROR = "GET_CALL_CAMPAIGN_STATS_BY_ID_ERROR"

//GET LEAD CAMPAIGNS AGGREGATED INFO
export const GET_LEAD_CAMPAIGN_STATS = "GET_LEAD_CAMPAIGN_STATS"
export const GET_LEAD_CAMPAIGN_STATS_SUCCESS = "GET_LEAD_CAMPAIGN_STATS_SUCCESS"
export const GET_LEAD_CAMPAIGN_STATS_ERROR = "GET_LEAD_CAMPAIGN_STATS_ERROR"

export const GET_LEAD_CAMPAIGN_STATS_BY_ID = "GET_LEAD_CAMPAIGN_STATS_BY_ID"
export const GET_LEAD_CAMPAIGN_STATS_BY_ID_SUCCESS = "GET_LEAD_CAMPAIGN_STATS_BY_ID_SUCCESS"
export const GET_LEAD_CAMPAIGN_STATS_BY_ID_ERROR = "GET_LEAD_CAMPAIGN_STATS_BY_ID_ERROR"

export const GET_FILTER_PACKAGES = "GET_FILTER_PACKAGES"
export const GET_FILTER_PACKAGES_SUCCESS = "GET_FILTER_PACKAGES_SUCCESS"
export const GET_FILTER_PACKAGES_ERROR = "GET_FILTER_PACKAGES_ERROR"

//Get source settings
export const GET_CAMPAIGNS_SOURCE_SETTINGS = "GET_CAMPAIGNS_SOURCE_SETTINGS"
export const GET_CAMPAIGNS_SOURCE_SETTINGS_SUCCESS = "GET_CAMPAIGNS_SOURCE_SETTINGS_SUCCESS"
export const GET_CAMPAIGNS_SOURCE_SETTINGS_ERROR = "GET_CAMPAIGNS_SOURCE_SETTINGS_ERROR"

//Bid multiplier change history (BM-8936)
export const GET_BID_MULTIPLIER_HISTORY = "GET_BID_MULTIPLIER_HISTORY"
export const GET_BID_MULTIPLIER_HISTORY_SUCCESS = "GET_BID_MULTIPLIER_HISTORY_SUCCESS"
export const GET_BID_MULTIPLIER_HISTORY_ERROR = "GET_BID_MULTIPLIER_HISTORY_ERROR"

// Ad group bid multiplier history (BM-9253)
export const GET_AD_GROUP_BID_MULTIPLIER_HISTORY = "GET_AD_GROUP_BID_MULTIPLIER_HISTORY"
export const GET_AD_GROUP_BID_MULTIPLIER_HISTORY_SUCCESS = "GET_AD_GROUP_BID_MULTIPLIER_HISTORY_SUCCESS"
export const GET_AD_GROUP_BID_MULTIPLIER_HISTORY_ERROR = "GET_AD_GROUP_BID_MULTIPLIER_HISTORY_ERROR"

export const GET_ACTIVE_CAMPAIGNS_FOR_SOURCES = "GET_ACTIVE_CAMPAIGNS_FOR_SOURCES"
export const GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_SUCCESS = "GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_SUCCESS"
export const GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_ERROR = "GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_ERROR"

/* GET DEFAULT TRANSFER NUMBER FOR CURRENT ACCOUNT FOR CAMPAIGN LEAD TYPE ID */
export const GET_DEFAULT_TRANSFER_NUMBER = "GET_DEFAULT_TRANSFER_NUMBER";
export const GET_DEFAULT_TRANSFER_NUMBER_SUCCESS = "GET_DEFAULT_TRANSFER_NUMBER_SUCCESS";
export const GET_DEFAULT_TRANSFER_NUMBER_ERROR = "GET_DEFAULT_TRANSFER_NUMBER_ERROR";

export const SET_PREVIOUS_LEAD_TYPE_ID = 'SET_PREVIOUS_LEAD_TYPE_ID';

/* GET AD GROUP STATS V4 FOR QUOTE FUNNELS */
export const GET_AD_GROUP_STATS_V4 = "GET_AD_GROUP_STATS_V4";
export const GET_AD_GROUP_STATS_V4_SUCCESS = "GET_AD_GROUP_STATS_V4_SUCCESS";
export const GET_AD_GROUP_STATS_V4_ERROR = "GET_AD_GROUP_STATS_V4_ERROR";
